import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { AddressFieldDisplayCollectionModel } from "@insite/client-framework/Types/ApiModels";
import {
    AddressValidationResultModel,
    validateAddress,
    ValidationAddressModel,
} from "@SupplyLand/Services/AddressValidationService";
import { CustomActions } from "@SupplyLand/Store/Components/AddressValidation/AddressValidationReducer";
import { DispatchProp } from "react-redux";

type ValidateAddressParameter = {
    onError?: (error: string) => void;
} & {
    inputAddress: ValidationAddressModel;
    addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
} & HasOnSuccess<AddressValidationResultModel>;

type Props = DispatchProp<CustomActions>;

type HandlerType = ApiHandler<ValidateAddressParameter, AddressValidationResultModel, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await validateAddress(props.apiParameter.inputAddress);
    if (result === null || result === undefined) {
        return false;
    }
    props.apiResult = result;
};

export const SetFormErrors: HandlerType = props => {
    if (
        props.apiResult.validationResult.dpv === false &&
        (props.apiResult.validationResult.invalidSuiteNumber ||
            props.apiResult.validationResult.suiteRequiredButMissing)
    ) {
        const formErrors = {} as AddressErrors;
        if (props.apiResult.validationResult.invalidSuiteNumber) {
            formErrors.address1 = " ";
            formErrors.address2 = "Please verify that address 2 is valid";
        }
        if (props.apiResult.validationResult.suiteRequiredButMissing) {
            formErrors.address1 = " ";
            formErrors.address2 = "Suite/Apt/Bldg required";
        }
        if (props.apiParameter.inputAddress.addressType === "billing") {
            props.dispatch({
                type: "Pages/CheckoutShipping/SetBillingAddressFormErrors",
                formErrors,
            });
        } else {
            props.dispatch({
                type: "Pages/CheckoutShipping/SetShippingAddressFormErrors",
                formErrors,
            });
        }
    }
};

export const DispatchResults: HandlerType = props => {
    props.dispatch({
        type: "SupplyLand/AddressValidation/ReturnAddressValidation",
        addressValidationResult: <AddressValidationResultModel>props.apiResult,
        inputAddress: <ValidationAddressModel>props.apiParameter.inputAddress,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    // if (props.apiResult..error) {
    //     // markSkipOnCompleteIfOnErrorIsSet(props);
    //     // props.parameter.onError?.(props.error);
    // }
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    SetFormErrors,
    DispatchResults,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const validateInputAddress = createHandlerChainRunner(chain, "ValidateInputAddress");

export default validateInputAddress;
